module.exports = __webpack_public_path__ + "static/media/TableScratch2_Before.85fb958d.jpg";